import getAPIPath from '../modules/api-location';

window.addFavouriteService = function(modelID, modelType, successFn) {
  const item = {};
  item.model_id = modelID;
  item.model_type = modelType;

  return $.ajax({
    url: `${getAPIPath}commandapi/favourite`,
    type: 'post',
    data: JSON.stringify(item),
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.deleteFavouriteService = function(modelID, modelType, successFn, errorFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/favourite?model_id=${modelID}&model_type=${modelType}`,
    type: 'delete',
    success: successFn,
    error: errorFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },
  });
};



// WEBPACK FOOTER //
// ./library/js/services/favourite.service.js